module.exports = __webpack_public_path__ + "assets/images/ending8_e2b309d26fdb6a45a77ff9525ac5418a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ending/ending8.png
// module id = 140
// module chunks = 0